const errorMapping = {
    // generic
    "INTERNAL_ERROR" : 'An internal server error occurred.',
    'BAD_REQUEST': 'Invalid request.',
    "NOT_ALLOWED": "This action is not allowed.",
    "UNAUTHORIZED": 'You are not authorized to perform this action.',

    'FORBIDDEN': "You don't have permission for this action.",
    'USER_NOT_FOUND': 'User not found.',
    'USER_EXISTS': 'An account with this email already exists.',

    'INVALID_CREDENTIALS': 'Invalid credentials.',

    'NOT_FOUND': 'The requested resource was not found.',
    'LIMIT_EXCEEDED': 'The limit has been exceeded.',
    'ALREADY_EXISTS': 'This resource already exists.',

    'FILE_SIZE_EXCEEDED': 'File size exceeded.',
    'FILE_MISSING': 'A file is required.',
    'FILE_EXT_NOT_ALLOWED': 'The selected file format is not allowed.',

    // validation errors
    // school
    'SEVP_CODE_INVALID': 'Please enter a valid SEVP code.',
    'STATE_INVALID': 'Invalid state selected.',
    'SCHOOL_NOT_FOUND': 'School not found.',
    'SCHOOL_EXISTS': 'School already exists.',
    'SCHOOL_NOT_ACTIVE': 'This school is not active.',

    // staff & students
    'FIRST_NAME_EMPTY': 'First name cannot be empty.',
    'MIDDLE_NAME_EMPTY': 'Middle name cannot be empty.',
    'LAST_NAME_EMPTY': 'Last name cannot be empty.',
    'EMAIL_INVALID': 'Please enter a valid email address.',
    'PHONE_EMPTY': 'Phone number cannot be empty.',
    'SEX_INVALID': 'Invalid gender selected.',

    // staff
    'ROLES_EMPTY': 'Please select at least one role.',
    'ROLE_INVALID': 'An invalid role was selected.',

    // students
    'MAIN_STATUS_REQUIRED': 'A main status is required when filtering by inner status.',
    'STUDENT_STATUS_COMBINATION_INVALID': 'The selected student status combination is not valid.',
    'BIRTHDATE_INVALID': 'Please enter a valid birthdate.',
    'STUDENT_NOT_ACTIVE': 'Only active students can be assigned to a group.',

    // notes
    'NOTE_EMPTY': 'Note content cannot be empty. Erase spaces or add text.',

    // address
    'ADDRESS_LINE_EMPTY': 'Address line cannot be empty.',
    'ADDRESS_CITY_EMPTY': 'City cannot be empty.',
    'ADDRESS_PROVINCE_EMPTY': 'Province cannot be empty.',
    'ADDRESS_COUNTRY_INVALID': 'Invalid country selected.',
    'ADDRESS_ZIP_CODE_EMPTY': 'ZIP code cannot be empty.',
    'ADDRESS_STATE_INVALID': 'Invalid state selected.',

    // auth
    'PASSWORD_INVALID': 'The password you entered is not valid.',

    // agent
    'CONTACT_NAME_EMPTY': 'Contact name cannot be empty.',
    'EMAIL_OR_PHONE_REQUIRED': 'At least one of email or phone is required.',

    // term
    'TERM_DATE_INTERSECTION': 'The term dates conflict with an existing term.',
    'STUDENT_ALREADY_IN_TERM_GROUP': 'This student is already in a group for this term.',

    // invoices
    'WRONG_AMOUNT': 'Wrong amount entered.',
    'INVALID_DISCOUNT_TYPE': 'Invalid discount type chosen',

    // common
    'UPDATE_EMPTY': 'At least one field must be provided for update.',
    
    'START_DATE_AFTER_END_DATE': 'The start date cannot be after the end date.',
    'END_DATE_INVALID': 'End date must be after the start date.',
    'START_DATE_ZERO': 'Start date is required.',
    'END_DATE_ZERO': 'End date is required.',

    'STATUS_INVALID': 'Invalid status selected.',
    'TYPE_INVALID': 'Invalid type selected.',

    'NAME_EMPTY': 'Name cannot be empty.',
    'NAME_TOO_LONG': 'Name must be less than 128 characters.',

    'TEXT_EMPTY': 'Text cannot be empty.',
    'TEXT_TOO_LONG': 'Text must be less than 1024 characters.',

    'DESCRIPTION_EMPTY': 'Description cannot be empty.',
    'DESCRIPTION_TOO_LONG': 'Description too long.',

    'NOT_IMPLEMENTED': 'Service is in development process. Come back later.',
};

export const mapErrorMessage = (errorCode) => {
    return errorMapping[errorCode] || 'An unexpected error occurred. Please try again.';
};